import { AppContext } from '../context';
import { useNotNullableContext } from './useNotNullableContext';

export const useApp = () => useNotNullableContext(AppContext);
